/* tslint:disable */

import { ReaderInlineDataFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type useMeasurementUnit_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "useMeasurementUnit_itemSearch";
};
export type useMeasurementUnit_itemSearch$data = useMeasurementUnit_itemSearch;
export type useMeasurementUnit_itemSearch$key = {
    readonly " $data"?: useMeasurementUnit_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"useMeasurementUnit_itemSearch">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useMeasurementUnit_itemSearch"
};
(node as any).hash = '2620b9e9552fd0e5e00c63233d3acf5f';
export default node;
